"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgTag(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M10.34 0a.963.963 0 01.68.282l8.666 8.666a.963.963 0 01.002 1.359l-5.38 5.41a.964.964 0 01-1.364 0L4.28 7.021A.963.963 0 014 6.34V.963A.963.963 0 014.963 0zM7.37 1.925a1.444 1.444 0 100 2.888 1.444 1.444 0 000-2.888z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Tag')(SvgTag);
//# sourceMappingURL=Tag.js.map